// spark.js — kleine Verlaufslinie (nur Zahlen, an Tokens gebunden). Für Tabellenzeilen und Kennzahl-Karten.
import { html, unsafeHtml } from '../core/h.js';

/** Punkte für eine Linie in einem w×h-Feld; ohne Ausschlag (alles 0) liegt sie unten. */
export function sparkPoints(values, w = 80, h = 22) {
  const v = (values || []).map((x) => Math.max(0, Number(x) || 0));
  if (!v.length) return '';
  const max = Math.max(1, ...v), step = v.length > 1 ? w / (v.length - 1) : 0;
  return v.map((x, i) => (i * step).toFixed(1) + ',' + (h - 1 - (x / max) * (h - 2)).toFixed(1)).join(' ');
}
export function sparkline(values, { label = '', w = 80, h = 22 } = {}) {
  const pts = sparkPoints(values, w, h);
  const total = (values || []).reduce((s, x) => s + (Number(x) || 0), 0);
  const area = pts ? `0,${h} ${pts} ${w},${h}` : '';
  return html`<span class="vc-spark${total ? '' : ' is-flat'}" role="img" aria-label="${label || 'Verlauf'}: ${total}">${unsafeHtml(
    `<svg viewBox="0 0 ${w} ${h}" width="${w}" height="${h}" aria-hidden="true" focusable="false"><polygon class="vc-spark-area" points="${area}"/><polyline class="vc-spark-line" points="${pts}"/></svg>`)}</span>`;
}
